var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Info(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7090",
    "data-name": "Rectangle 7090",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-svgrepo-com",
    transform: "translate(2.792 2.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M18.759,9.383A9.379,9.379,0,1,0,9.38,18.762,9.379,9.379,0,0,0,18.759,9.383Z",
    transform: "translate(0 0)",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(6.598 2.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M179.832,165.077a.189.189,0,0,0-.237-.064,22.066,22.066,0,0,1-2.191.946.183.183,0,0,1-.024-.028.248.248,0,0,1-.042-.152,27.955,27.955,0,0,1,1.179-4.753,16.533,16.533,0,0,0,.736-2.817.717.717,0,0,0-.26-.573,1.027,1.027,0,0,0-.67-.2,3.51,3.51,0,0,0-1.669.547,8.972,8.972,0,0,0-2.094,1.8.189.189,0,0,0,.211.3c.266-.109,1.6-.656,1.8-.779a.82.82,0,0,1,.411-.151h.01a.2.2,0,0,1,0,.035,1.428,1.428,0,0,1-.07.4,33.515,33.515,0,0,0-1.693,6.919,1.151,1.151,0,0,0,.281.814,1,1,0,0,0,.762.307,2.658,2.658,0,0,0,1.251-.429,14.58,14.58,0,0,0,2.282-1.88A.189.189,0,0,0,179.832,165.077Z",
    transform: "translate(-174.511 -154.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M263.437,69.362a.952.952,0,0,0-.708-.287,1.205,1.205,0,0,0-.914.415,1.412,1.412,0,0,0-.376.987,1.044,1.044,0,0,0,.277.748.929.929,0,0,0,.7.295,1.208,1.208,0,0,0,.909-.438,1.443,1.443,0,0,0,.392-1A1,1,0,0,0,263.437,69.362Z",
    transform: "translate(-258.152 -69.075)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Info);
export default __webpack_public_path__ + "static/media/icon-24-info.aee50c2ca2ca836e297fc39fc8e9ed3e.svg";
export { ForwardRef as ReactComponent };